import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation} from 'react-i18next';
import BookingModal from '../../../page/bookingModal';
const PharmacyHeading = (props) => {
    const { t, i18n } = useTranslation();

    return (
        <>
            <div className="row">
                <div className="col-lg-12">
                    <div className="pharmacy_heading_wrapper">
                        <div className="grocery_heading">
                            {/* <h2 className='sofia'>{props.heading}</h2> */}
                            
                            {props.heading==='Recommended' && <small className='text-warn'>{t('recommendedyousubheading')}</small>}
                            
                            {props.heading==='Recommended' && <h2>{t('recommendedyou')}</h2>}
                            {props.heading==='Deals of The Month' && <h2 className='sofia'>{t('dealofmonth')}</h2>}
                            {props.heading==='Featured Services' && <h2 className='sofia'>{t('featuredservices')}</h2>}
                            {props.heading==='Featured Packages' && <h2 className='sofia'>{t('featuredpackages')}</h2>}
                        </div>
                        <div className={i18n.language==='ar'?"view_all_arae_ar":"view_all_arae"}>
                        {props.heading==='Recommended' &&  !props.hidebooking &&  <span className='d-none d-lg-block'><BookingModal type="generic"/></span>}
                            {props.heading==='Deals of The Month' && <Link to={{ pathname: `/estore`, state: { type: 'coupon' } }}>{t('viewall')}</Link>}
                            {props.heading==='Featured Services' && <Link to={{ pathname: `/estore`, state: { type: 'product' } }}>{t('viewall')}</Link>}
                            {props.heading==='Featured Packages' && <Link to={{ pathname: `/estore`, state: { type: 'package' } }} >{t('viewall')}</Link>}
                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PharmacyHeading